/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Picks_Done_TitleInputs */

const en_daily_picks_done_title = /** @type {(inputs: Daily_Picks_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You’ve collected them all!`)
};

const ar_daily_picks_done_title = /** @type {(inputs: Daily_Picks_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لقد جمعتها كلها!`)
};

const de_daily_picks_done_title = /** @type {(inputs: Daily_Picks_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast alle gesammelt!`)
};

const es_daily_picks_done_title = /** @type {(inputs: Daily_Picks_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Los has coleccionado todos!`)
};

const fr_daily_picks_done_title = /** @type {(inputs: Daily_Picks_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu les as tous collectionnés !`)
};

const it_daily_picks_done_title = /** @type {(inputs: Daily_Picks_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Li hai collezionati tutti!`)
};

const ja_daily_picks_done_title = /** @type {(inputs: Daily_Picks_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて集めました！`)
};

const ko_daily_picks_done_title = /** @type {(inputs: Daily_Picks_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모두 모았어요!`)
};

const pt_br_daily_picks_done_title = /** @type {(inputs: Daily_Picks_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você colecionou todos!`)
};

const ru_daily_picks_done_title = /** @type {(inputs: Daily_Picks_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы собрали всё!`)
};

const th_daily_picks_done_title = /** @type {(inputs: Daily_Picks_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณสะสมครบทั้งหมดแล้ว!`)
};

const tr_daily_picks_done_title = /** @type {(inputs: Daily_Picks_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hepsini topladın!`)
};

const zh_cn_daily_picks_done_title = /** @type {(inputs: Daily_Picks_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部收集完成！`)
};

const zh_tw_daily_picks_done_title = /** @type {(inputs: Daily_Picks_Done_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部收集完成！`)
};

/**
* | output |
* | --- |
* | "You’ve collected them all!" |
*
* @param {Daily_Picks_Done_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_picks_done_title = /** @type {((inputs?: Daily_Picks_Done_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Picks_Done_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_picks_done_title(inputs)
	if (locale === "ar") return ar_daily_picks_done_title(inputs)
	if (locale === "de") return de_daily_picks_done_title(inputs)
	if (locale === "es") return es_daily_picks_done_title(inputs)
	if (locale === "fr") return fr_daily_picks_done_title(inputs)
	if (locale === "it") return it_daily_picks_done_title(inputs)
	if (locale === "ja") return ja_daily_picks_done_title(inputs)
	if (locale === "ko") return ko_daily_picks_done_title(inputs)
	if (locale === "pt_br") return pt_br_daily_picks_done_title(inputs)
	if (locale === "ru") return ru_daily_picks_done_title(inputs)
	if (locale === "th") return th_daily_picks_done_title(inputs)
	if (locale === "tr") return tr_daily_picks_done_title(inputs)
	if (locale === "zh_cn") return zh_cn_daily_picks_done_title(inputs)
	return zh_tw_daily_picks_done_title(inputs)
});